import DTO from './DTO';
import DtoType from './converters/DtoType';
import ScheduleDTO from './ScheduleDTO';
import { ZONE_TYPE } from '../configs';

class ZoneDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'name',
        type: String,
        validators: [],
        labelKey: 'name',
      },
      {
        name: 'description',
        type: String,
        validators: [],
        labelKey: 'description',
      },
      {
        name: 'type',
        type: Number,
        validators: [],
        labelKey: 'zone.type',
      },
      {
        name: 'capacity',
        type: Number,
        validators: [],
        labelKey: 'zone.capacity',
      },
      {
        name: 'status',
        type: Number,
        validators: [],
        labelKey: 'zone.status',
      },
      {
        name: 'schedule',
        type: DtoType(ScheduleDTO),
        validators: [],
        labelKey: 'schedule',
      },
      {
        name: 'created_at',
        type: String,
        validators: [],
        labelKey: 'created_at',
      },
      {
        name: 'area',
        type: Object,
        validators: [],
        labelKey: 'area',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }

  getFormData() {
    const d = {
      area: this.area,
      name: this.name,
      description: this.description,
      type: this.type,
      capacity: this.capacity,
      status: this.status || 0,
    };
    if (this.type === ZONE_TYPE.CONDITIONAL) {
      d.schedule = this.schedule.getData();
    }
    if (this.type === ZONE_TYPE.FORBIDDEN) {
      delete d.capacity;
    }
    return d;
  }
}

export default ZoneDTO;
